import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../../utils'
import { Box } from '../../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faEdit, faEye, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../../Components/CustomUi/loading'
import { ItensFertilizantes } from '../../../../../../services/fertilizante/GET'
import { useEffect, useRef, useState } from 'react'

interface Props {
  loading: boolean
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_fertilizantes: ItensFertilizantes[]
  abrirGaveta: Function
  permissao: ItensPerUserLogged
  editarCadastro?: Function
  duplicar: Function
  deletar?: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  filtroAtivado?: boolean
  setFiltroAtivado?: React.Dispatch<React.SetStateAction<boolean>>
  totalRef: number
}

export const TabelaFertilizantes: React.FC<Props> = ({
  loading,
  buscarTabela,
  setBuscarTabela,
  page,
  setPage,
  setPagination,
  total,
  listar_fertilizantes,
  abrirGaveta,
  permissao,
  editarCadastro,
  duplicar,
  deletar,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  setFiltroAtivado,
  totalRef
}) => {


  const lista_fertilizante_aplicacoes = listar_fertilizantes?.map((item) => ({
    ...item,
    aplicacoes: item?.aplicacoes.map((aplica) => aplica?.aplicacao_nome),
  }))

  function buscarFertilizantes(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      const fabricante = removerAcentos(String(item?.marca_nome))
      const filtrarAplicacao = removerAcentos(String(item?.aplicacoes))
      return (
        fabricante.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        filtrarAplicacao.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        !buscar_nome
      )
    }
  }

  return (
    <Box style={{ height: 'calc(100vh - 180px)' }} gap={10} borderless>
      <Inline alignItems='center'>
        <Input
          placeholder='Buscar fertilizantes, fabricante, aplicações'
          value={buscarTabela}
          onChange={setBuscarTabela}
        />
        <ButtonCustom
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={abrirGaveta}
          hidden={permissao?.acesso === 1}
        >
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: '251px' },
          { valor: 'Aplicações', width: '250px' },
          { valor: 'Fabricante', width: '130px' },
          { valor: 'Observação', width: 'calc(100% - 855.5px)' },
          { valor: 'Ações', width: '220.5px' },
        ]}
      />

      <BodyTable
        paginate={totalRef}
        paginateFilter={
          buscarTabela
            ? (lista_fertilizante_aplicacoes ?? []).filter(buscarFertilizantes(buscarTabela)).length
            : undefined
        }
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (listar_fertilizantes ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(lista_fertilizante_aplicacoes ?? [])
            .filter(buscarFertilizantes(buscarTabela))
            .map(({ cod, nome, aplicacoes, observacao, marca_nome }) => {
              return (
                <RowTable
                  key={cod}
                  onDoubleClick={() => editarCadastro(cod)}
                  style={{ height: 'auto' }}
                >
                  <RowItem fontSize={12} style={{ alignItems: 'center' }} width={'250px'}>
                    {nome}
                  </RowItem>

                  <RowItem
                    fontSize={12}
                    width={'250px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {aplicacoes
                      ?.filter((word) => word !== '')
                      .map((item) => {
                        return (
                          <Tag color='green' key={item} style={{ margin: 5 }}>
                            {item}
                          </Tag>
                        )
                      })}
                  </RowItem>
                  <RowItem fontSize={12} width={'130px'}>
                    {marca_nome}
                  </RowItem>
                  <RowItem fontSize={12} width={'calc(100% - 850px)'}>
                    {observacao}
                  </RowItem>
                  <RowItem width={'220px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading}
                      hidden={permissao?.acesso === 1}
                      typeButtonTrigger='tertiary'
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faCopy} />}
                      onClick={() => duplicar(cod)}
                      hidden={permissao?.acesso === 1}
                      type='secondary'
                    />

                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={permissao?.acesso === 1 ? faEye : faEdit} />}
                      onClick={() => editarCadastro(cod)}
                    >
                      {permissao?.acesso === 1 ? 'Ver' : 'Editar'}
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={listar_fertilizantes?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando fertilizantes...'
            justifyContent='center'
            height={'100%'}
            size='default'
          />
        </Render>
      </BodyTable>
    </Box>
  )
}
